import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { afterItems, beforeItems } from "../../data/content";
import { CTAButton } from "../CTAButton";
export function BeforeAfter() {
  return <section className="bg-white px-4 py-16" data-id="element-84" data-mp="26luonyxbie5l">
      <div className="mx-auto max-w-5xl" data-id="element-85" data-mp="26mmbak8xt1jq">
        <p className="text-center text-[13px] font-bold uppercase tracking-wider text-gold" data-id="element-86" data-mp="22lavf6fv7uoq">Before vs. After</p>
        <h2 className="mx-auto mt-2 max-w-2xl text-center font-serif text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-87" data-mp="2zba2ewgdal57">
          What changes when you use a structured revision-case review system?
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-88" data-mp="2q90ri5h6spra">
          <div className="rounded-3xl border-2 border-red-200 bg-red-50 p-5 sm:p-7" data-id="element-89" data-mp="2lbisb6sz1owh">
            <div className="flex items-center gap-3" data-id="element-90" data-mp="1ev6rsz2ofuxq">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-red-600 text-white" data-id="element-91" data-mp="1evyc3dqtq68p">
                <XIcon className="h-6 w-6" aria-hidden data-id="element-92" data-mp="19usi7clfgcxl" />
              </span>
              <h3 className="text-[22px] font-extrabold uppercase tracking-wide text-red-700" data-id="element-93" data-mp="176fai36vg1va">Before</h3>
            </div>
            <ul className="mt-5 space-y-3" data-id="element-94" data-mp="1c3ny4jasgy3x">
              {beforeItems.map(t => <li key={t} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-95" data-mp="y3wf245f0rj2">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden data-id="element-96" data-mp="132ptbysj0mka" />
                  {t}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta/40 bg-green-50 p-5 sm:p-7" data-id="element-97" data-mp="t64nxcclh9fx">
            <div className="flex items-center gap-3" data-id="element-98" data-mp="fegc7a69cmzh">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cta text-white" data-id="element-99" data-mp="fg15kwgu5zvr">
                <CheckIcon className="h-6 w-6" aria-hidden data-id="element-100" data-mp="jg1mcnreqn5z" />
              </span>
              <h3 className="text-[19px] font-extrabold uppercase leading-tight tracking-wide text-ctadark" data-id="element-101" data-mp="5ginymoeeq6v">
                With the Atlas™
              </h3>
            </div>
            <ul className="mt-5 space-y-3" data-id="element-102" data-mp="2c4j34igj3mst">
              {afterItems.map(t => <li key={t} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-103" data-mp="27d0xhh3k8y1i">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden data-id="element-104" data-mp="23bpg1yuubj4e" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-xl text-center font-serif text-[24px] font-bold leading-snug text-ink" data-id="element-105" data-mp="2v34z5ix6unpv">
          The goal is simple: structure your revision-case review in approximately{" "}
          <em className="text-gold" data-id="element-106" data-mp="2m26v50mr2g7a">15 minutes</em>.
        </p>
        <CTAButton className="mt-8" label="I want to review cases with a system" data-id="element-107" data-mp="2m0m1rec693b0" />
      </div>
    </section>;
}